import GenericPressable from './implementation';

export default GenericPressable;
